import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import ArticleLicensingRoutes from './routes/ArticleLicensingRoutes';
import ScrollToTop from '../../common/components/ScrollToTop';

const container = document.getElementById('app-mountpoint');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <div className="article-licensing">
      <ArticleLicensingRoutes />
    </div>
  </BrowserRouter>,
);
